import React from 'react'
import { useTranslation } from '@mc/i18n'
import { TableFeature, useTiersInfo } from '@mc/plans-ui'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../../../i18n'
import { PricingCell } from './PricingCell'

export const DefaultPricingFeature = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const { individual, duo, family } = useTiersInfo()

  return (
    <TableFeature.Feature>
      <TableFeature.Label title={t('plans.features.pricing.title')} />
      <TableFeature.Individual>
        <PricingCell tier={individual} />
      </TableFeature.Individual>
      <TableFeature.Duo>
        <PricingCell tier={duo} />
      </TableFeature.Duo>
      <TableFeature.Family>
        <PricingCell tier={family} />
      </TableFeature.Family>
    </TableFeature.Feature>
  )
}
